import { editorPicks } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function EditorPicks() {
  return (
    <section id="picks" className="bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="本期主推片单"
          title="编辑精选：这一轮值得先看的片子"
          desc="我们从站内收录里挑出四部角度各异的作品，每部都配了短摘要，看标题和一句话就知道合不合口味。"
          actionLabel="订阅固定片单"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {editorPicks.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-bold text-primary-200">{item.rank}</span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">{item.tag}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
                <span className="text-xs text-foreground-500">{item.meta}</span>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-600">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                  {item.score}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}